import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Vue from "vue";
import Router from "vue-router";
import Home from "../components/views/Home";
import Help from "../components/views/Help";
import Dashboard from "../components/views/Dashboard";
import ThematicSelection from "../components/views/ThematicSelection";
import ProjectEdition from "../components/views/ProjectEdition";
import SubtitleEdition from "../components/views/SubtitleEdition";
import VideoEdition from "../components/views/VideoEdition";
import VideoEdition2 from "../components/views/VideoEdition2";
import VoiceOverEdition from "../components/views/VoiceOverEdition";
import ImageRightsAgreement from "../components/views/ImageRightsAgreement";

Vue.use(Router);
Vue.use(BootstrapVue);

const ifNoAuthenticated = (to, from, next) => {
	sessionStorage.clear();
	next();
};

const ifAuthenticated = (to, from, next) => {
	if (sessionStorage.getItem("username") && sessionStorage.getItem("isConnected")) {
		next();
		return;
	}
	next("/");
};

export default new Router({
	hashbang: false,
	routes: [
		{
			mode: "history",
			path: "/",
			name: "Home",
			component: Home,
			hashbang: false,
			props: true,
			beforeEnter: ifNoAuthenticated,
		},
		{
			mode: "history",
			path: "/dashboard",
			name: "Dashboard",
			component: Dashboard,
			hashbang: false,
			props: true,
			beforeEnter: ifAuthenticated,
		},
		{
			hashbang: false,
			mode: "history",
			path: "/thematic-selection",
			name: "ThematicSelection",
			component: ThematicSelection,
			props: true,
			beforeEnter: ifAuthenticated,
		},
		{
			mode: "history",
			path: "/form_privacy",
			name: "ImageRightsAgreement",
			component: ImageRightsAgreement,
			hashbang: false,
			props: true,
		},
	  {
		  mode: "history",
		  path: "/help",
		  name: "Help",
		  component: Help,
		  hashbang: false,
		  props: true,
	  },
		{
			hashbang: false,
			mode: "history",
			path: "/project/:id",
			name: "ProjectEdition",
			component: ProjectEdition,
			props: true,
			beforeEnter: ifAuthenticated,
			children: [
				{
					hasbang: false,
					mode: "history",
					props: true,
					path: "subtitles_edit/:step_type/:stepId",
					name: "SubtitleEdition",
					component: SubtitleEdition,
					beforeEnter: ifAuthenticated,
				},
				{
					hashbang: false,
					mode: "history",
					path: "video_edit/:step_type/:stepId",
					name: "VideoEdition",
					component: VideoEdition,
					props: true,
					beforeEnter: ifAuthenticated,
				},
				{
					hashbang: false,
					mode: "history",
					path: "video_edit/:step_type/:stepId/:filename",
					name: "VideoEdition2",
					component: VideoEdition2,
					props: true,
					beforeEnter: ifAuthenticated,
				},
				{
					hashbang: false,
					mode: "history",
					path: "voiceOver_edit/:step_type/:stepId",
					name: "VoiceOverEdition",
					component: VoiceOverEdition,
					props: true,
					beforeEnter: ifAuthenticated,
				},
			],
		},
	],
});
